var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var extractMentionedAdminUserIds = function (mentions) {
    return Array.from(new Set(mentions
        .map(function (mention) { return mention.id; })
        .filter(function (mentionId) { return typeof mentionId === 'number'; })));
};
export var findChangeRange = function (currentText, nextText) {
    var start = 0;
    while (start < currentText.length &&
        start < nextText.length &&
        currentText[start] === nextText[start]) {
        start += 1;
    }
    var currentEnd = currentText.length;
    var nextEnd = nextText.length;
    while (currentEnd > start &&
        nextEnd > start &&
        currentText[currentEnd - 1] === nextText[nextEnd - 1]) {
        currentEnd -= 1;
        nextEnd -= 1;
    }
    return { start: start, currentEnd: currentEnd, nextEnd: nextEnd };
};
export var recalculateMentionsAfterTextChange = function (currentText, nextText, mentions) {
    var _a = findChangeRange(currentText, nextText), start = _a.start, currentEnd = _a.currentEnd, nextEnd = _a.nextEnd;
    var shift = nextEnd - currentEnd;
    return mentions
        .map(function (mention) {
        if (mention.end <= start)
            return mention;
        if (mention.start >= currentEnd) {
            return __assign(__assign({}, mention), { start: mention.start + shift, end: mention.end + shift });
        }
        return null;
    })
        .filter(function (mention) { return mention !== null; })
        .filter(function (mention) { return nextText.slice(mention.start, mention.end) === mention.label; });
};
